import i18n from '@/i18n';
export default {
  eventAddColumHeader: [
    {
      id: 'name',
      textLabel: i18n.t('主旨'),
      type: 'text',
      width: '43%',
    },
    {
      id: 'status',
      textLabel: i18n.t('狀態'),
      type: 'chip',
      width: '13%',
    },
    {
      id: 'date',
      textLabel: i18n.t('發生時間'),
      timeIcon: 'icon-time',
      type: 'date',
      width: '20%',
    },
    {
      id: 'owner',
      textLabel: i18n.t('負責人'),
      type: 'avatar',
      width: '16%',
    },
    {
      id: 'icon',
      textLabel: '',
      type: 'icon',
      width: '4%',
    },
  ],
  eventAddRowData: [
    {
      id: 1,
      name: '事件主旨事件主旨事件主旨事件主旨',
      status: {
        color: 'yellow',
        text: '處理中',
      },
      date: '11:22',
      owner: {
        name: '阿花',
        avatar: '',
      },
      icon: {
        icon: 'icon-arrow-right',
        path: '/factory/1/event-content/1',
      },
    },
  ],
  eventTotalColumHeader: [
    {
      id: 'name',
      textLabel: i18n.t('主旨'),
      type: 'text',
      width: '35%',
    },
    {
      id: 'status',
      textLabel: i18n.t('狀態'),
      type: 'chip',
      width: '13%',
    },
    {
      id: 'date',
      textLabel: i18n.t('發生時間'),
      timeIcon: 'icon-date',
      type: 'date',
      width: '28%',
    },
    {
      id: 'owner',
      textLabel: i18n.t('負責人'),
      type: 'avatar',
      width: '16%',
    },
    {
      id: 'icon',
      textLabel: '',
      type: 'icon',
      width: '4%',
    },
  ],
  eventTotalRowData: [
    {
      id: 1,
      name: 'total事件主旨事件主旨事件主旨事件主旨',
      status: {
        color: 'yellow',
        text: '處理中',
      },
      date: '2021.22.22 11:11',
      owner: {
        name: '阿花',
        avatar: '',
      },
      icon: {
        icon: 'icon-arrow-right',
        path: '/factory/1/event-content/1',
      },
    },
  ],
  alertAddColumHeader: [
    {
      id: 'name',
      textLabel: i18n.t('主旨'),
      type: 'text',
      width: '59%',
    },
    {
      id: 'status',
      textLabel: i18n.t('狀態'),
      type: 'chip',
      width: '13%',
    },
    {
      id: 'date',
      textLabel: i18n.t('發生時間'),
      timeIcon: 'icon-time',
      type: 'date',
      width: '20%',
    },
    {
      id: 'icon',
      textLabel: '',
      type: 'icon',
      width: '4%',
    },
  ],
  alertAddRowData: [
    {
      id: 1,
      name: '主旨',
      status: {
        color: 'gray',
        text: '未排除',
      },
      date: '11:11',
      icon: {
        icon: 'icon-arrow-right',
        path: '/factory/1/alert-content/1',
      },
    },
  ],
  alertTotalColumHeader: [
    {
      id: 'name',
      textLabel: i18n.t('主旨'),
      type: 'text',
      width: '49%',
    },
    {
      id: 'status',
      textLabel: i18n.t('狀態'),
      type: 'chip',
      width: '13%',
    },
    {
      id: 'date',
      textLabel: i18n.t('發生時間'),
      timeIcon: 'icon-time',
      type: 'date',
      width: '30%',
    },
    {
      id: 'icon',
      textLabel: '',
      type: 'icon',
      width: '4%',
    },
  ],
  alertTotalRowData: [
    {
      id: 1,
      name: '主旨',
      status: {
        color: 'gray',
        text: '未排除',
      },
      date: '2021.07.07 11:11',
      icon: {
        icon: 'icon-arrow-right',
        path: '/factory/1/alert-content/1',
      },
    },
  ],
  taskAddColumHeader: [
    {
      id: 'name',
      textLabel: i18n.t('主旨'),
      type: 'text',
      width: '60%',
    },
    {
      id: 'date',
      textLabel: i18n.t('期限'),
      timeIcon: 'icon-duedate',
      type: 'expired',
      width: '20%',
    },
    {
      id: 'owner',
      textLabel: i18n.t('負責人'),
      type: 'avatar',
      width: '16%',
    },
    {
      id: 'icon',
      textLabel: '',
      type: 'icon',
      width: '4%',
    },
  ],
  taskAddRowData: [
    {
      id: 1,
      name: '主旨',
      date: '2021.07.07',
      owner: {
        name: '阿花',
        avatar: '',
      },
      icon: {
        icon: 'icon-arrow-right',
        path: '/factory/1/event-content/1',
      },
    },
  ],
  taskTotalColumHeader: [
    {
      id: 'name',
      textLabel: i18n.t('主旨'),
      type: 'text',
      width: '60%',
    },
    {
      id: 'date',
      textLabel: i18n.t('期限'),
      timeIcon: 'icon-duedate',
      type: 'expired',
      width: '20%',
    },
    {
      id: 'owner',
      textLabel: i18n.t('負責人'),
      type: 'avatar',
      width: '16%',
    },
    {
      id: 'icon',
      textLabel: '',
      type: 'icon',
      width: '4%',
    },
  ],
  taskTotalRowData: [
    {
      id: 1,
      name: '主旨',
      date: '2021.07.07',
      owner: {
        name: '阿花',
        avatar: '',
      },
      icon: {
        icon: 'icon-arrow-right',
        path: '/factory/1/event-content/1',
      },
    },
  ],
  licenseAddColumHeader: [
    {
      id: 'name',
      textLabel: i18n.t('名稱'),
      type: 'text',
      width: '36%',
    },
    {
      id: 'status',
      textLabel: i18n.t('辦理狀態'),
      type: 'chip',
      width: '10%',
    },
    {
      id: 'date',
      textLabel: i18n.t('到期日'),
      timeIcon: 'icon-duedate',
      type: 'expired',
      width: '20%',
    },
    {
      id: 'owner',
      textLabel: i18n.t('持有人'),
      type: 'avatar',
      width: '16%',
    },
    {
      id: 'manager',
      textLabel: i18n.t('管理者'),
      type: 'avatar',
      width: '16%',
    },
    {
      id: 'icon',
      textLabel: '',
      type: 'icon',
      width: '4%',
    },
  ],
  licenseAddRowData: [
    {
      id: 1,
      name: '名稱',
      status: {
        color: 'yellow',
        text: '辦理中',
      },
      date: '2021.07.07',
      owner: {
        name: '阿花',
        avatar: '',
      },
      manager: {
        name: '阿花m',
        avatar: '',
      },
      icon: {
        icon: 'icon-arrow-right',
        path: '/factory/1/license-content-main/1',
      },
    },
  ],
  licenseTotalColumHeader: [
    {
      id: 'name',
      textLabel: i18n.t('名稱'),
      type: 'text',
      width: '36%',
    },
    {
      id: 'status',
      textLabel: i18n.t('狀態'),
      type: 'chip',
      width: '10%',
    },
    {
      id: 'date',
      textLabel: i18n.t('期限'),
      timeIcon: 'icon-duedate',
      type: 'expired',
      width: '20%',
    },
    {
      id: 'owner',
      textLabel: i18n.t('持有人'),
      type: 'avatar',
      width: '16%',
    },
    {
      id: 'manager',
      textLabel: i18n.t('管理者'),
      type: 'avatar',
      width: '16%',
    },
    {
      id: 'icon',
      textLabel: '',
      type: 'icon',
      width: '4%',
    },
  ],
  licenseTotalRowData: [
    {
      id: 1,
      name: '名稱',
      status: {
        color: 'yellow',
        text: '辦理中',
      },
      date: '2021.07.07',
      owner: {
        name: '阿花',
        avatar: '',
      },
      manager: {
        name: '阿花m',
        avatar: '',
      },
      icon: {
        icon: 'icon-arrow-right',
        path: '/factory/1/license-content-main/1',
      },
    },
  ],
  changeAddColumHeader: [
    {
      id: 'name',
      textLabel: i18n.t('名稱'),
      type: 'text',
      width: '60%',
    },
    {
      id: 'date',
      textLabel: i18n.t('建立日期'),
      timeIcon: 'icon-date',
      type: 'date',
      width: '20%',
    },
    {
      id: 'owner',
      textLabel: i18n.t('負責人'),
      type: 'avatar',
      width: '16%',
    },
    {
      id: 'icon',
      textLabel: '',
      type: 'icon',
      width: '4%',
    },
  ],
  changeAddRowData: [
    {
      id: 1,
      name: '名稱',
      date: '2021.07.07',
      owner: {
        name: '阿花',
        avatar: '',
      },
      icon: {
        icon: 'icon-arrow-right',
        path: '/factory/1/change-content/1',
      },
    },
  ],
  changeTotalColumHeader: [
    {
      id: 'name',
      textLabel: i18n.t('名稱'),
      type: 'text',
      width: '60%',
    },
    {
      id: 'date',
      textLabel: i18n.t('到期日'),
      timeIcon: 'icon-duedate',
      type: 'expired',
      width: '20%',
    },
    {
      id: 'owner',
      textLabel: i18n.t('負責人'),
      type: 'avatar',
      width: '16%',
    },
    {
      id: 'icon',
      textLabel: '',
      type: 'icon',
      width: '4%',
    },
  ],
  changeTotalRowData: [
    {
      id: 1,
      name: '變動計畫名稱變動計畫名稱變動計畫名稱',
      date: '2021.07.07',
      owner: {
        name: '阿花',
        avatar: '',
      },
      icon: {
        icon: 'icon-arrow-right',
        path: '/factory/1/change-content/1',
      },
    },
  ],
  contractorAddColumHeader: [
    {
      id: 'date',
      textLabel: i18n.t('進場時間'),
      type: 'text',
      width: '20%',
    },
    {
      id: 'name',
      textLabel: i18n.t('作業內容'),
      type: 'text',
      width: '43%',
    },
    {
      id: 'status',
      textLabel: i18n.t('狀態'),
      type: 'chip',
      width: '13%',
    },
    {
      id: 'owner',
      textLabel: i18n.t('負責人'),
      type: 'avatar',
      width: '16%',
    },
    {
      id: 'icon',
      textLabel: '',
      type: 'icon',
      width: '4%',
    },
  ],
  contractorAddRowData: [
    {
      id: 1,
      name:
        '東東維修公司：維修C棟排維修C棟排維修C棟修，維修C棟排維修C棟排維修C棟排維修',
      status: {
        color: 'red',
        text: '收工未檢查',
      },
      date: '11:22-21:21',
      owner: {
        name: '阿花',
        avatar: '',
      },
      icon: {
        icon: 'icon-arrow-right',
        path: '/factory/1/event-content/1',
      },
    },
    {
      id: 2,
      name:
        '東東維修公司：維修C棟排維修C棟排維修C棟修，維修C棟排維修C棟排維修C棟排維修',
      status: {
        color: 'red',
        text: '未復歸',
      },
      date: '11:22-21:21',
      owner: {
        name: '阿花',
        avatar: '',
      },
      icon: {
        icon: 'icon-arrow-right',
        path: '/factory/1/event-content/1',
      },
    },
  ],
  contractorTotalRowData: [
    {
      id: 1,
      name:
        '東東維修公司：維修C棟排維修C棟排維修C棟修，維修C棟排維修C棟排維修C棟排維修',
      date: '2021.05.10-2021.05.12 08:00-12:00',
      non_return: '2',
      uncheck: '12',
      owner: {
        name: '阿花',
        avatar: '',
      },
      icon: {
        icon: 'icon-arrow-right',
        path: '/factory/1/event-content/1',
      },
    },
    {
      id: 2,
      name:
        '東東維修公司：維修C棟排維修C棟排維修C棟修，維修C棟排維修C棟排維修C棟排維修',
      date: '11:22-21:21',
      owner: {
        name: '阿花',
        avatar: '',
      },
      icon: {
        icon: 'icon-arrow-right',
        path: '/factory/1/event-content/1',
      },
    },
  ],
  rankingColumnHeader: [
    {
      id: 'title',
      textLabel: i18n.t('題目名稱'),
      type: 'text',
      width: '80%',
    },
    {
      id: 'number',
      textLabel: i18n.t('累計'),
      type: 'text',
      width: '20%',
    },
  ],
};
